import React from 'react';
import PropTypes from 'prop-types';

import TranslationProvider from '../../providers/TranslationProvider';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';

import './Checkbox.scss';
import './MarketingOptInCheckbox.scss';

// these rules are deprecated, address later
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
const MarketingOptInCheckbox = ({ onChange, checked, isNonUS }) => {
  const optInTerms = 'By leaving this toggle off you will be opted out of marketing emails, however, you will still receive communications regarding your bookings for Resy restaurants, events, and experiences.';
  let translationKey;
  let text;

  if (isNonUS) {
    translationKey = 'marketing_accept_gdpr';
    text = 'Receive news and curated dining recommendations from Resy including Hit Lists, neighbourhood + cuisine guides, and chef interviews via email. All emails include an unsubscribe link. You can opt out at any time.';
  } else {
    translationKey = 'marketing_opt_in';
    text = 'Receive marketing emails';
  }

  if (isNonUS) {
    return (
      <div className="MarketingOptInCheckbox">
        <CheckboxGroup>
          <Checkbox
            checked={checked}
            onChange={onChange}
            name="marketing_opt_in_not_us"
          />
          <TranslationProvider translationKey={translationKey}>
            <label htmlFor="marketing_opt_in_not_us">{text}</label>
          </TranslationProvider>
        </CheckboxGroup>
      </div>
    );
  }
  return (
    <div className="MarketingOptInCheckbox resy-container">
      <TranslationProvider translationKey="marketing_opt_in_title">
        <p className="MarketingOptInCheckbox__header">Discover Restaurants to Love</p>
      </TranslationProvider>
      <TranslationProvider translationKey="marketing_opt_in_subhead">
        <p className="MarketingOptInCheckbox__subheader">Sign up for Resy emails to receive curated recommendations and insider tips on top restaurants in your area.</p>
      </TranslationProvider>

      <CheckboxGroup>
        <Checkbox
          asSwitch
          checked={checked}
          onChange={onChange}
          name="marketing_opt_in_us"
        />
        <TranslationProvider translationKey="marketing_opt_in">
          <label className="MarketingOptInCheckbox__switch-label" htmlFor="marketing_opt_in_us">{text}</label>
        </TranslationProvider>
      </CheckboxGroup>
      <TranslationProvider translationKey="marketing_opt_in_terms">
        <p className="MarketingOptInCheckbox__terms">{optInTerms}</p>
      </TranslationProvider>
    </div>
  );
};

MarketingOptInCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  isNonUS: PropTypes.bool,
};

MarketingOptInCheckbox.defaultProps = {
  checked: false,
  isNonUS: true,
};

export default MarketingOptInCheckbox;
/* eslint-enable */
